// lib/api/auth.ts
import axiosInstance from './axios';
import { API_ENDPOINTS } from './config';
import { ApiError } from './error';
import {
    LoginRequestType,
    LoginResponseType,
    CurrentUserType
} from '@/types';

/**
 * 로그인 API
 */
export async function loginApi(loginData: LoginRequestType): Promise<LoginResponseType> {
    try {
        const data = await axiosInstance.post(
            API_ENDPOINTS.AUTH.LOGIN,
            loginData
        );
        return data as LoginResponseType;
    } catch (error) {
        throw ApiError.fromAxiosError(error);
    }
}

/**
 * 로그아웃 API
 */
export async function logoutApi(): Promise<void> {
    try {
        await axiosInstance.post(API_ENDPOINTS.AUTH.LOGOUT);
    } catch (error) {
        // 로그아웃은 실패해도 로컬 처리
        console.error('Logout API error:', error);
    } finally {
        // 로컬 스토리지 정리
        logout();
    }
}

/**
 * 현재 사용자 정보 조회
 */
export async function getCurrentUserApi(): Promise<CurrentUserType> {
    try {
        const data = await axiosInstance.get(API_ENDPOINTS.AUTH.ME);
        return data as CurrentUserType;
    } catch (error) {
        throw ApiError.fromAxiosError(error);
    }
}

/**
 * 토큰 갱신
 */
export async function refreshTokenApi(): Promise<{ token: string }> {
    try {
        const data = await axiosInstance.post(API_ENDPOINTS.AUTH.REFRESH);
        return data as { token: string };
    } catch (error) {
        throw ApiError.fromAxiosError(error);
    }
}

/**
 * 로그아웃 처리 (로컬)
 */
export function logout(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('userId');
    localStorage.removeItem('userName');
    localStorage.removeItem('adminGrade');

    window.location.href = '/login';
}

/**
 * 인증 상태 확인
 */
export function isAuthenticated(): boolean {
    const token = localStorage.getItem('token');
    const userId = localStorage.getItem('userId');
    return !!(token && userId);
}

/**
 * 현재 사용자 정보 가져오기 (로컬)
 */
export function getCurrentUser(): CurrentUserType {
    return {
        userId: localStorage.getItem('userId'),
        userName: localStorage.getItem('userName'),
        adminGrade: localStorage.getItem('adminGrade'),
        token: localStorage.getItem('token'),
    };
}

/**
 * 토큰 저장
 */
export function saveToken(token: string): void {
    localStorage.setItem('token', token);
}

/**
 * 사용자 정보 저장
 */
export function saveUserInfo(userInfo: Omit<CurrentUserType, 'token'>): void {
    if (userInfo.userId) localStorage.setItem('userId', userInfo.userId);
    if (userInfo.userName) localStorage.setItem('userName', userInfo.userName);
    if (userInfo.adminGrade) localStorage.setItem('adminGrade', userInfo.adminGrade);
}